/*
  Zenino: pastila galbena care aluneca intre categoriile din meniu (desktop).
  - Sta pe categoria paginii curente si urmareste mouse-ul; la plecare revine acolo.
  - Cat timp e deschis un meniu cu subcategorii, ramane pe categoria care l-a deschis
    si revine abia dupa ce meniul s-a inchis.
  - Pe ecrane tactile nu reactioneaza la atingeri (altfel iPad-ul cere doua atingeri pe link),
    dar arata categoria activa si meniul deschis prin atingere.
  - La derulare se ascunde odata cu randul de categorii si reapare dupa ce randul s-a deschis la loc.
  - Cu meniul de categorii Zenino (zn-nav), sta pe departamentul aratat in panou si urmeaza
    evenimentul zn:mega trimis de zn-nav.js.
  Fara JS, meniul are un fundal simplu la hover (vezi zenino-chrome.css si zn-nav.css).
*/
(function () {
  var desktop = window.matchMedia('(min-width: 769px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var header = document.querySelector('store-header.header') || document.querySelector('.header');
    var nav = header && (header.querySelector('.zn-nav__bar') || header.querySelector('.main-nav'));
    if (!nav || nav.classList.contains('zn-has-pill')) return;
    var custom = nav.classList.contains('zn-nav__bar');
    var ITEM = custom ? '.zn-nav__link' : '.main-nav__item--primary';
    if (!nav.querySelector(ITEM)) return;

    var pill = document.createElement('span');
    pill.className = 'zn-nav-pill';
    pill.setAttribute('aria-hidden', 'true');
    header.appendChild(pill);
    nav.classList.add('zn-has-pill');

    var speed = parseFloat(window.getComputedStyle(header).getPropertyValue('--header-transition-speed')) || 300;
    var current = null;
    var visible = false;
    var pointerInside = false;
    var hoverItem = null;
    var revealAt = 0;
    var revealTimer = 0;
    var frame = 0;

    /* categoria de prim nivel care contine elementul (link, buton sau panoul ei de subcategorii) */
    function primaryOf(node) {
      while (node && node !== nav) {
        if (node.parentNode === nav) return node.querySelector(ITEM);
        node = node.parentNode;
      }
      return null;
    }

    function openOwner() {
      if (custom) return nav.querySelector('.zn-nav__link.is-current-dept');
      var open = nav.querySelector(':scope > li > details.is-open');
      return open ? primaryOf(open) : null;
    }

    function hot(el) {
      if (current === el) return;
      if (current) current.classList.remove('zn-is-hot');
      current = el;
      if (el) el.classList.add('zn-is-hot');
    }

    function hide() {
      if (!visible) return;
      pill.style.opacity = '0';
      visible = false;
    }

    function place(el) {
      if (!el || !desktop.matches || header.classList.contains('is-out')) { hide(); return; }
      /* randul de categorii inca se deschide dupa derulare: pastila apare cand e gata */
      var wait = revealAt - Date.now();
      if (wait > 0) {
        clearTimeout(revealTimer);
        revealTimer = setTimeout(refresh, wait);
        return;
      }
      var hr = header.getBoundingClientRect();
      var nr = nav.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      if (!r.width) { hide(); return; }
      var jump = !visible || reduce.matches;
      if (jump) pill.classList.add('zn-no-anim');
      /* stratul acopera tot randul; se vede doar fereastra decupata pe categoria curenta,
         asa ca miscarea animeaza doar masca (clip-path), nu latimea sau pozitia */
      pill.style.width = nr.width + 'px';
      pill.style.height = r.height + 'px';
      pill.style.transform = 'translate(' + (nr.left - hr.left) + 'px, ' + (r.top - hr.top) + 'px)';
      pill.style.clipPath = 'inset(0 ' + (nr.right - r.right) + 'px 0 ' + (r.left - nr.left) + 'px round 999px)';
      pill.style.opacity = '1';
      visible = true;
      if (jump && !reduce.matches) {
        pill.getBoundingClientRect();
        window.requestAnimationFrame(function () { pill.classList.remove('zn-no-anim'); });
      }
    }

    function go(el) {
      if (!el) return;
      hot(el);
      place(el);
    }

    /* unde se intoarce pastila cand mouse-ul nu mai e pe meniu */
    function rest() {
      var target = openOwner() || nav.querySelector(ITEM + '.is-active');
      hot(target);
      if (target) place(target); else hide();
    }

    function refresh() {
      frame = 0;
      if (current) place(current); else hide();
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(refresh);
    }

    function isTouch(e) {
      return e.pointerType === 'touch';
    }

    nav.addEventListener('pointerover', function (e) {
      if (isTouch(e)) return;
      pointerInside = true;
      var el = primaryOf(e.target);
      hoverItem = el;
      if (el) {
        if (el !== current) go(el);
      } else if (custom && e.target.closest('[data-zn-mega-trigger]')) {
        /* pe "Toate categoriile": pastila arata departamentul din panou */
        rest();
      }
    });

    nav.addEventListener('pointerleave', function (e) {
      if (isTouch(e)) return;
      pointerInside = false;
      hoverItem = null;
      rest();
    });

    /* panoul de categorii a schimbat departamentul, s-a inchis sau bara si-a ascuns linkuri care nu incap */
    nav.addEventListener('zn:mega', function () {
      if (hoverItem && hoverItem.offsetWidth) schedule();
      else rest();
    });

    nav.addEventListener('focusin', function (e) {
      var target = e.target;
      var keyboard = true;
      try { keyboard = target.matches(':focus-visible'); } catch (err) { /* browsere vechi */ }
      if (keyboard) go(primaryOf(target));
    });

    nav.addEventListener('focusout', function (e) {
      if (!nav.contains(e.relatedTarget) && !pointerInside) rest();
    });

    /* meniurile cu subcategorii: deschise la hover, click sau tastatura, inchise de tema.
       Ascultam doar elementele <details>, ca schimbarile noastre de clase sa nu reporneasca observatorul. */
    new MutationObserver(function (records) {
      var relevant = false;
      for (var i = 0; i < records.length && !relevant; i++) relevant = records[i].target.tagName === 'DETAILS';
      if (!relevant) return;
      var owner = openOwner();
      if (owner) {
        if (owner !== current) go(owner);
      } else if (!pointerInside) {
        rest();
      }
    }).observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });

    /* antetul lipicios: randul de categorii se strange la derulare in jos si revine la derulare in sus */
    var wasOut = header.classList.contains('is-out');
    new MutationObserver(function () {
      var out = header.classList.contains('is-out');
      if (out === wasOut) { schedule(); return; }
      wasOut = out;
      if (out) {
        clearTimeout(revealTimer);
        hide();
      } else {
        revealAt = Date.now() + speed;
        clearTimeout(revealTimer);
        revealTimer = setTimeout(refresh, speed);
      }
    }).observe(header, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', schedule);
    window.addEventListener('on:breakpoint-change', function () {
      if (desktop.matches) rest(); else hide();
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', schedule);
    }

    rest();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* editorul de teme reconstruieste antetul cand ii schimbi setarile */
  document.addEventListener('shopify:section:load', init);
})();
